import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const PlanningNavBlock = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap gap-lg justify-content-center">
      <Button
        className="nc_button-square"
        label="Units"
        icon="nc_icon-nc_unit icon-md"
        iconPos="right"
        aria-label="Units"
        rounded
        outlined
        onClick={() => navigate('/units')}
        id="navBlockUnits"
      />
      <Button
        label="Skills"
        icon="nc_icon-nc_challenge icon-md"
        iconPos="right"
        aria-label="Skills"
        rounded
        className="nc_button-square"
        outlined
        onClick={() => navigate('/skills')}
        id="navBlockSkills"
      />
    </div>
  );
};

export default PlanningNavBlock;
